import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import PopularSearches from '../components/PopularSearches';
import { Helmet } from 'react-helmet';
import { initializeCurrencyRates } from '../services/currencyService';
import CanonicalUrl from '../components/CanonicalUrl';

function HomePage() {
  useEffect(() => {
    // Fetch currencies and place them on the window object when component mounts
    initializeCurrencyRates();
  }, []);

  return (
    <>
      <Helmet>
        <title>בוא תימצא - BoTimza | השוואת מחירים באמזון</title>
        <meta name="description" content="בוא תמצא את המחיר הטוב ביותר! השוואת מחירים מהפכנית של כל האמזונים השונים בעולם בשניות" />
      </Helmet>
      <CanonicalUrl />
      <div className="seo-content" style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: '0' }}>
        <h1>בוא תימצא - השוואת מחירים באמזון</h1>
        <p>בוא תמצא את המחיר הטוב ביותר באמזון עם BoTimza. אמזונים שונים יכולים למכור את אותו המוצר במחירים שונים!</p>
      </div>
      <Hero />
      <PopularSearches />
    </>
  );
}

export default HomePage;
